import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { deactivateUserAPI, resetDeactivationStatus } from "../../redux/features/adminSlice";
const DeactivateUserModal = ({ show, onHide, userId, fullName, refreshDataHandler }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { deactivationStatus } = useSelector((state) => state.admin);
  const [formData, setFormData] = useState({
    reason: "",
    durationDays: 0,
  });
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (deactivationStatus.success) {
      toast.success("User deactivated successfully!", { position: "top-center" });
      dispatch(resetDeactivationStatus());
      onHide();
      if (refreshDataHandler) {
        refreshDataHandler();
      }
    } else if (deactivationStatus.error) {
      toast.error(deactivationStatus.error, { position: "top-center" });
      dispatch(resetDeactivationStatus());
    }
  }, [deactivationStatus, dispatch, onHide, refreshDataHandler]);
  const validateForm = () => {
    const newErrors = {};
    if (!formData.reason.trim()) {
      newErrors.reason = "Reason for deactivation is required.";
    }
    if (formData.durationDays <= 0) {
      newErrors.duration = "Duration must be greater than zero.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "reason" ? value : parseInt(value) || 0,
    }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!auth?.token) {
      toast.error("Please log in to deactivate user.", { position: "top-center" });
      return;
    }
    if (!validateForm()) {
      return;
    }
    try {
      await dispatch(
        deactivateUserAPI({
          token: auth.token,
          userId,
          payload: formData,
        })
      ).unwrap();
    } catch (error) {
      // Error is handled via Redux state
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className="border-0" style={{ position: "relative", padding: "1.5rem" }}>
        <Modal.Title className="w-100 text-center" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
          Deactivate User: {fullName || "User"}
        </Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
          style={{ position: "absolute", right: "1rem", top: "1rem" }}
        />
      </Modal.Header>
      <Modal.Body className="text-center" style={{ padding: "1.5rem" }}>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-16 text-start">
            <Form.Label className="fw-semibold">Reason for Deactivation</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              isInvalid={!!errors.reason}
              placeholder="Enter the reason for deactivation"
              style={{
                borderRadius: "6px",
                borderColor: errors.reason ? "#DC3545" : "#CED4DA",
                padding: "0.5rem",
              }}
            />
            <Form.Control.Feedback
              type="invalid"
              style={{ fontSize: "0.875rem", color: "#DC3545" }}
            >
              {errors.reason}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3 text-start">
            <Form.Label className="fw-semibold">Duration (Days)</Form.Label>
            <Form.Control
              type="number"
              name="durationDays"
              value={formData.durationDays}
              onChange={handleChange}
              min="0"
              placeholder="Days"
              className="form-control p-0 text-center"
              isInvalid={!!errors.duration}
            />
            <Form.Control.Feedback
              type="invalid"
              style={{ fontSize: "0.875rem", color: "#DC3545" }}
            >
              {errors.duration}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0" style={{ padding: "1rem 1.5rem" }}>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
        <button type="button" onClick={handleSubmit} className="btn btn-primary">
          {deactivationStatus.loading ? (
            <div className="dottedLoading"></div>
          ) : "Deactivate User"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};
export default DeactivateUserModal;